import { render, staticRenderFns } from "./PaPremiumSummary.vue?vue&type=template&id=a74ba89c&scoped=true"
import script from "./PaPremiumSummary.vue?vue&type=script&lang=js"
export * from "./PaPremiumSummary.vue?vue&type=script&lang=js"
import style0 from "./PaPremiumSummary.vue?vue&type=style&index=0&id=a74ba89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74ba89c",
  null
  
)

export default component.exports